/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Optimistic_LockInputs */

const cs_api_error_optimistic_lock = /** @type {(inputs: Api_Error_Optimistic_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Někdo jiný to mezitím změnil. Obnovte a zkuste znovu.`)
};

const en_api_error_optimistic_lock = /** @type {(inputs: Api_Error_Optimistic_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Someone else changed this. Reload and try again.`)
};

/**
* | output |
* | --- |
* | "Someone else changed this. Reload and try again." |
*
* @param {Api_Error_Optimistic_LockInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_optimistic_lock = /** @type {((inputs?: Api_Error_Optimistic_LockInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Optimistic_LockInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_optimistic_lock(inputs)
	return cs_api_error_optimistic_lock(inputs)
});